import { Mic, MicOff } from "lucide-react";
import { useTranslation } from "react-i18next";

import { Button } from "@/components/ui/button";
import StatusMessage from "@/components/ui/status-message";

import useVoiceConversation from "../hooks/useVoiceConversation";
import msLogo from "../assets/microsoft-logo.svg";

export default function MSDemoLayout() {
    const { isRecording, onToggleRecording } = useVoiceConversation();
    const { t } = useTranslation();

    const onToggleListening = async () => {
        console.log("Button clicked. Recording is currently:", isRecording);
        onToggleRecording();
    };

    return (
        <div className="flex min-h-screen flex-col bg-gray-100 text-gray-900">
            <div className="p-4 sm:absolute sm:left-4 sm:top-4">
                <img src={msLogo} alt="Microsoft logo" className="h-12" />
            </div>
            <main className="flex flex-grow flex-col items-center justify-center">
                <h1 className="mb-8 bg-gradient-to-r from-blue-600 to-blue-800 bg-clip-text text-4xl font-bold text-transparent md:text-7xl">
                    Microsoft AI Demo
                </h1>
                <div className="mb-4 flex flex-col items-center justify-center">
                    <Button
                        onClick={onToggleListening}
                        className={`h-12 w-60 ${isRecording ? "bg-red-600 hover:bg-red-700" : "bg-blue-500 hover:bg-blue-600"}`}
                        aria-label={isRecording ? t("app.stopRecording") : t("app.startRecording")}
                    >
                        {isRecording ? (
                            <>
                                <MicOff className="mr-2 h-4 w-4" />
                                {t("app.stopConversation")}
                            </>
                        ) : (
                            <>
                                <Mic className="mr-2 h-6 w-6" />
                                {t("app.startConversation")}
                            </>
                        )}
                    </Button>
                    <StatusMessage isRecording={isRecording} />
                </div>
            </main>

            <footer className="py-4 text-center">
                <p>© Microsoft Corporation. All rights reserved.</p>
            </footer>
        </div>
    );
}
